import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Header from '../../Shared/Header/Header';
import AboutContent from '../AboutContent/AboutContent';

const About = () => {
    return (
        <div>
            <Header></Header>
            <AboutContent></AboutContent>
            <Footer></Footer>
            
        </div>
    );
};

export default About;